define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/table/AggregateFrom"
], function(array,declare,lang,csi,AggregateFrom) {

	return declare(AggregateFrom, {
		getFormData: function() {
			// summary: add hook into form data to determine if node is already selected
			var fd = this.inherited(arguments);
			fd.m_bOmitSelections = true;
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
			return fd;
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			// Get newly created ColorColorwayContext-s in the order specified in 'ColorColorways' attribute on Theme
			var returnNodes;
			if (this.m_response) {
				var action = this.getAction();
				var nodeParent = this.getParent();
				var allChildNodeURLs = nodeParent[action.aggregateId];
				var	newChildNodes = this.m_response.getNodesOfType(action.aggregateClass);

				if (newChildNodes && newChildNodes.length) {
					returnNodes = csi.transform(allChildNodeURLs,function(childNodeURL){
						var node = null;
						array.some(newChildNodes,function(newNode){
							if (newNode.$URL == childNodeURL)
								node = newNode;
							return node != null;
						});
						return node;
					});
				}
			}
			return returnNodes || [];
		},

		_isPreSelected: function(/*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
			// summary: determine if ColorMaterial.ColorSpecification is in aggregation list
			var	node = ctx.getNode();
			ctx.pushParams().setNodeURL(node.ColorSpecification);
			var	b = fd.isAggregated(ctx, false, true);
			ctx.pop();
			return b;
		}
	});
});